export const getDomainKey = () => window.location.hostname.replaceAll(".", "_")
